/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

import React from 'react';

export default function Us() {
  return (
    <a href="https://www.datayes.com/contact.html" target="_blank" className="header-icon">
      关于我们
    </a>
  );
}
